import logoBooking from 'sealink/images/booking.com.svg';
import logoHotels from 'sealink/images/hotels.com.svg';
import logoKlook from 'sealink/images/klook.com.svg';
import logoRezdy from 'sealink/images/rezdy.com.svg';
import logoViator from 'sealink/images/viator.com.svg';

export const LOGOS = {
  'hotels.com.svg': {
    logo: logoHotels,
    alt: 'Hotels.com',
  },
  'booking.com.svg': {
    logo: logoBooking,
    alt: 'Booking.com',
  },
  'klook.com.svg': {
    logo: logoKlook,
    alt: 'Klook.com',
  },
  'rezdy.com.svg': {
    logo: logoRezdy,
    alt: 'Rezdy.com',
  },
  'viator.com.svg': {
    logo: logoViator,
    alt: 'Viator.com',
  },
};
